<template>
    <div
        class="card-list"
        :class="{
            'card-list--list': appearance === 'inline',
            'card-list--hybrid': appearance === 'hybrid',
            'card-list--triple': appearance === 'triple',
        }"
    >
        <div v-show="!items || items?.length === 0" class="card-list__no-results">
            <slot name="noItems" />
        </div>
        <div v-show="items?.length !== 0" class="card-list__items">
            <div
                v-for="item in items"
                :key="item.id"
                class="card-list__item"
            >
                <slot :item="item" />
            </div>
        </div>

        <div class="card-list__cta">
            <slot name="cta" />
        </div>
    </div>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        required: true
    },
    appearance: {
        type: String,
        default: 'list',
        validator: (value) => ['list', 'hybrid', 'triple'].includes(value)
    }
});
</script>

<style src="./BaseCardList.less" lang="less" />
